import PropTypes from 'prop-types';
import { useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Card, CardContent, Typography, Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import AvatarDisplay from 'src/components/widgets/avatar-display';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';

export const DetailPhone = forwardRef(({ item, onTrackingClicked, onGroupClicked }, ref) => {
  const editorRef = useRef();
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    setDataFromParent: (value) => {
      // console.log('==', value);
    },
  }));

  useImperativeHandle(ref, () => ({
    setDataFromParent: (value) => {
      console.log('==', value);
    },
  }));


  // console.log('==>>>>', item);

  return (
    <Card>
      <CardContent sx={{ px: 0, py: 1 }}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <ReadOnlyTextField label="Họ tên" value={item.name} />
          </Grid>
          
          <Grid xs={6}>
            <ReadOnlyTextField label="Số điện thoại" value={item.phone} enumType='phone'/>
          </Grid>

          <Grid xs={6}>
            <ReadOnlyTextField label="Sinh nhật" value={item.birthday} />
          </Grid>

          <Grid xs={12}>
            <ReadOnlyTextField label="Người liên hệ" value={item.partnerContact} />
          </Grid>

          <Grid xs={6}>
            <ReadOnlyTextField label={t(appStr.txt_073)} value={item.degreeName} />
          </Grid>

          <Grid xs={6}>
            <ReadOnlyTextField label="Khóa học" value={item.courseName} />
          </Grid>

          <Grid xs={12}>
            <QuillEditor
              ref={editorRef}
              value={item.note}
              isReadOnly={true}
              sx={{ height: 96 }}
            />
          </Grid>

          <Grid xs={12}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
              <Typography variant="body2" color="text.secondary">
                Tiến độ:
              </Typography>
              <Typography
                variant="subtitle1"
                color="primary"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => {
                  onTrackingClicked(item);
                }}
              >
                {item.trackingName || 'Xem chi tiết'}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{mt: 2.5}}>
              <Typography variant="body2" color="text.secondary">
                Trạng thái:
              </Typography>
              <Typography variant="subtitle1">
                {item.statusName}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{mt: 2.5}}>
              <Typography variant="body2" color="text.secondary">
                Ghi chú:
              </Typography>
              <Typography variant="body2">
                {item.trackingNote}
              </Typography>
            </Stack>
          </Grid>
              
          <Grid xs={12}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
              <Typography variant="body2" color="text.secondary">
                Đầu mối:
              </Typography>
              <Typography
                variant="subtitle1"
                color="primary"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => {
                  onGroupClicked(item);
                }}
              >
                {item.groupName || 'Xem chi tiết'}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{mt: 2.5}}>
              <Typography variant="body2" color="text.secondary">
                Số buổi học:
              </Typography>
              <Typography
                variant="subtitle1"
                color="primary"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => {
                  //trackingClicked(item);
                }}
              >
                
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{mt: 2.5}}>
              <Typography variant="body2" color="text.secondary">
                Tổng thời gian:
              </Typography>
              <Typography variant="subtitle1">
                
              </Typography>
            </Stack>
          </Grid>          
        </Grid>
      </CardContent>
    </Card>
  );
});

DetailPhone.propTypes = {
  item: PropTypes.object.isRequired,
  apiUpdate: PropTypes.func,
  apiDelete: PropTypes.func,
};